import { createStore, applyMiddleware, compose } from "redux";
import { routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";
import { createBrowserHistory } from "history";
import throttle from "lodash/throttle";
import { loadState, saveState } from "./localStorage";
import rootReducer from "../reducers";

window.addEventListener("storage", (event) => {
  if (event.key === "certState" && event.newValue === null) {
    store.dispatch({ type: "LOGOUT_FULFILLED" });
  }
});

export const history = createBrowserHistory();

const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV === "development") {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const persistedState = loadState();

const store = createStore(rootReducer, persistedState, composedEnhancers);

store.subscribe(
  throttle(() => {
    const { auth } = store.getState();
    saveState({ auth });
  }, 1000),
);

export default store;
